import { render } from "./kanban-board.vue?vue&type=template&id=bae40b6c&scoped=true"
import script from "./kanban-board.vue?vue&type=script&lang=js"
export * from "./kanban-board.vue?vue&type=script&lang=js"

import "./kanban-board.vue?vue&type=style&index=0&id=bae40b6c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae40b6c"]])

export default __exports__